import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\SendToChiftInvoicingController::__invoke
* @see app/Http/Controllers/Invoice/SendToChiftInvoicingController.php
* @route '/api/invoicing/{invoice}/send-to-chift-invoicing'
*/
const SendToChiftInvoicingController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendToChiftInvoicingController.url(args, options),
    method: 'post',
})

SendToChiftInvoicingController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/send-to-chift-invoicing',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\SendToChiftInvoicingController::__invoke
* @see app/Http/Controllers/Invoice/SendToChiftInvoicingController.php
* @route '/api/invoicing/{invoice}/send-to-chift-invoicing'
*/
SendToChiftInvoicingController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return SendToChiftInvoicingController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\SendToChiftInvoicingController::__invoke
* @see app/Http/Controllers/Invoice/SendToChiftInvoicingController.php
* @route '/api/invoicing/{invoice}/send-to-chift-invoicing'
*/
SendToChiftInvoicingController.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendToChiftInvoicingController.url(args, options),
    method: 'post',
})

export default SendToChiftInvoicingController